<template>
  <v-card
    v-if="props.reocurringTasks?.length === 0"
    class="mt-3 mb-3"
  >
    <v-card-title>
      No re-occurring task found.
    </v-card-title>
    <v-card-text>
      There are no re-occurring tasks currently assigned to you.
    </v-card-text>
  </v-card>
  <VCard v-if="props.reocurringTasks && props.reocurringTasks.length > 0">
    <v-card-title>
      Assigned re-occurring items
    </v-card-title>
    <v-card-text>
      <v-list>
        <v-list-item
          v-for="(item, index) of props.reocurringTasks"
          :key="item.id"
        >
          {{ item.template.name }} @ {{ d(item.plannedDate, { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }) }}
        </v-list-item>
      </v-list>
    </v-card-text>
  </VCard>
</template>

<script setup lang="ts">
import {ReoccurringTasks} from "@/stores/reoccuringTaskStore";
import {useI18n} from "vue-i18n";

const { d, locale } = useI18n();

const props = defineProps({
  reocurringTasks: Array as PropType<ReoccurringTasks[]>,
})


</script>
